const QUERY_DESTINATION_PARAM = 'destination',
  QUERY_DESTINATION_CHAT_PARAM = 'chat';

export { QUERY_DESTINATION_PARAM, QUERY_DESTINATION_CHAT_PARAM };
